<template>
  <a-drawer :label-col="4" :visible="open" :wrapper-col="14" width="35%" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="师傅订单id,外键{zb_master_order.id}" prop="masterOrderId">
        <a-input v-model="form.masterOrderId" placeholder="请输入师傅订单id,外键{zb_master_order.id}"/>
      </a-form-model-item>
      <a-form-model-item label="打赏类型,0-打赏,1-辅材" prop="rewardType">
      </a-form-model-item>
      <a-form-model-item label="金额" prop="rewardPrice">
        <a-input v-model="form.rewardPrice" placeholder="请输入金额"/>
      </a-form-model-item>
      <a-form-model-item label="说明" prop="describe">
        <a-input v-model="form.describe" placeholder="请输入说明"/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" allow-clear placeholder="请输入内容" type="textarea"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button :loading="submitLoading" type="primary" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getReward, addReward, updateReward} from '@/api/reward/reward'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        masterOrderId: null,

        rewardType: null,

        rewardPrice: null,

        describe: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        masterOrderId: [
          {required: true, message: '师傅订单id,外键{zb_master_order.id}不能为空', trigger: 'blur'}
        ],
        rewardType: [
          {required: true, message: '打赏类型,0-打赏,1-辅材不能为空', trigger: 'change'}
        ],
        rewardPrice: [
          {required: true, message: '金额不能为空', trigger: 'blur'}
        ],
        describe: [
          {required: true, message: '说明不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        masterOrderId: null,
        rewardType: null,
        rewardPrice: null,
        describe: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getReward({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateReward(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addReward(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
